import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets-cm19k8pv.emergentagent.net/job_a03997ba-1196-47d5-9215-27d1eb255f12/artifacts/vxczuo9a_Color%20logo%20with%20background.webp';

export default function Logo({ variant = 'wordmark', className = '' }) {
  if (variant === 'mark') {
    return (
      <Link to="/" aria-label="Evermark home" className={className} data-testid="site-logo">
        <img src={LOGO_URL} alt="Evermark" className="h-10 w-10 object-contain dark:invert" />
      </Link>
    );
  }
  return (
    <Link to="/" aria-label="Evermark home" className={`inline-flex items-center gap-3 ${className}`} data-testid="site-logo">
      <img src={LOGO_URL} alt="" className="h-9 w-9 object-contain dark:invert" aria-hidden />
      <span className="font-display text-2xl tracking-[0.16em] leading-none">EVERMARK</span>
    </Link>
  );
}
